export const DOCUMENT_CATEGORIES = [
  'Church Report',
  'District Report',
  'Ministry Report',
  'Annual Report',
  'Meeting Document',
  'Form',
  'Newsletter',
  'Other',
];

// Extensions allowed at upload time. Keep in sync with any bucket-level
// restriction you configure in Supabase Storage.
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'image/jpeg',
  'image/png',
];

export const ALLOWED_FILE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.jpg',
  '.jpeg',
  '.png',
];

// 20MB — adjust to whatever's sensible for district reports/scans.
export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
